import React, { useState, useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as actionsStock from '../../../../actions/stockAction';
import { Input, Button, Breadcrumbs, ListPaginationNew, ConfirmModal } from '../../../../components/UI/ComponentsUI';
import { translate, formatData, showMessageToastCustom } from '../../../../utils/util';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import StockService from '../../../../services/StockService';

const ListMailer = (props) => {
    const formType = props.location?.state?.formType;
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [itemDelete, setItemDelete] = useState(null);
    const [filter, setFilter] = useState({
        name: '',
        formType: formType,
        email: ''
    });

    useEffect(() => {
        if (props.data?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData([...props.data.items]);
            } else {
                setData((prevState) => ([...prevState, ...props.data.items]));
            }
        } else {
            setData([]);
        }

        // eslint-disable-next-line
    }, [props?.data?.items]);

    useEffect(() => {
        onClickButton();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            onClickButton();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onClickButton = (click) => {
        var currentPageList = currentPage;
        if (click) {
            currentPageList = 0;
            setCurrentPage(0);
        }

        props.getMailerPaged({
            ...filter,
            PageSize: 20,
            PageIndex: currentPageList
        });
    }

    const onDelete = () => {
        props.deleteItem(itemDelete.id, () => {
            showMessageToastCustom(translate('general.info'), translate('sucess-to-delete', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            onClickButton(true);
        })
    }


    const onClickDelete = (item) => {
        setItemDelete(item)
        const modal = M.Modal.init(document.getElementById('confirmDelete'));
        modal.open();
    }

    const renderItem = (item, index) => {
        return (
            <>
                <span className="above-btn sixth-text-color right" style={{ marginRight: '30px' }}>
                    <i style={{ cursor: 'pointer' }} onClick={() => onClickDelete(item)} className="mdi mdi-delete"></i>
                </span>
                <Link
                    key={`link-${index}`}
                    className="row"
                    style={{ display: 'block', marginBottom: '0px' }}
                    to={{ pathname: 'insert', state: { update: true } }}
                    onClick={() => {
                        if (props.setMailer) {
                            props.setMailer(item);
                        }
                    }}
                >
                    <span className="title sixth-text-color">{`${item.name || ""}`}</span>
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{`${item.email || ""}`}</span>
                    <span
                        className="truncate second-text-color"
                        style={{ marginLeft: '10px' }}
                    >
                        {item.createdBy} - {item.createdByDesc}
                    </span>
                    <span
                        className="truncate second-text-color"
                        style={{ marginLeft: '10px' }}
                    >
                        {formatData(item.createdOn)}
                    </span>
                </Link>
            </>
        )
    }

    return (
        <>
            <Breadcrumbs id="pickinginvoice" title={{ icon: "mdi mdi-email-search-outline", label: translate('list-email', 'stock') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className='container'>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formInvoice" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        label={translate('name', 'stock')}
                                        id="name"
                                        name='name'
                                        type="text"
                                        maxLength="100"
                                        onChange={onChange}
                                        value={filter.name}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        label={translate('email', 'stock')}
                                        id="email"
                                        name="email"
                                        type="text"
                                        onChange={onChange}
                                        value={filter.email}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <Button full='true' onClick={() => onClickButton(true)} text={translate('search', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
                <ListPaginationNew
                    page={props.data?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={data.map((item, index) => (
                        renderItem(item, index)
                    ))}
                />
            </div>
            <ConfirmModal
                id="confirmDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onDelete}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        data: state.stockReducer.mailers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMailerPaged: (filter, callback) => {
            dispatch(StockService.getMailerPaged(filter, callback));
        },
        setMailer: (mailer) => {
            dispatch(actionsStock.setMailer(mailer))
        },
        deleteItem: (id, callback) => {
            dispatch(StockService.deleteMailer(id, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListMailer)));